import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[100vh] min-h-[680px] flex items-center overflow-hidden" style={{ marginTop: "-68px" }}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/759ed09f7e517d1f42db84e30e8c6d8b.jpg"
          alt="ARAVELLA outdoor furniture"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6">
        <div className="max-w-xl">
          <span className="inline-block text-[#A8D080] text-sm font-medium tracking-widest uppercase mb-5 border border-[#A8D080]/40 px-4 py-1.5 rounded-full">
            Premium Outdoor Living
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Elevate Your<br />
            <em className="not-italic text-[#A8D080]">Outdoor</em> Space
          </h1>
          <p className="text-white/75 text-lg leading-relaxed mb-10 max-w-md">
            Discover handcrafted outdoor furniture built to last. From teak loungers to wicker sectionals — designed for the way you live outside.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/products"
              className="bg-[#2D5016] hover:bg-[#3d6826] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm tracking-wide"
            >
              Shop Collection
            </Link>
            <Link
              to="/reviews"
              className="border-2 border-white/60 hover:border-white text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm tracking-wide"
            >
              Customer Reviews
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8 mt-14">
            {[
              { value: "30+", label: "Products" },
              { value: "500+", label: "Happy Customers" },
              { value: "4.7★", label: "Average Rating" },
            ].map(stat => (
              <div key={stat.label}>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-white/50 text-xs tracking-wide mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg"></i>
      </div>
    </section>
  );
}
